const FormAuth = {
  parts: [
    'header',
    'title',
    'description',
    'subtitle',
    'buttonContainer',
    'buttonGroup',
    'buttonSubmit',
    'buttonOutline',
    'divider',
    'policy',
    'policyText',
    'policyLink',
    'buttonForgotPassword'
  ],
  baseStyle: {
    header: {
      gap: {base: 6, md: 4},
    },
    title: {
      color: 'brandColors.greyscale90',
      fontSize: {base: '28px', md: '32px'},
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '0'},
    },
    subtitle: {
      color: 'brandColors.greyscale',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
    },
    description: {
      color: 'brandColors.greyscale90',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%',
      letterSpacing: '0',
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: {base: 6, md: 8},
      mt: {base: 6, md: 8},
    },
    buttonGroup: {
      gap: 4,
    },
    buttonSubmit: {
      display: 'flex',
      height: 13.5,
      py: 4,
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      alignSelf: 'stretch',
      color: 'white',
      textAlign: 'center',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      borderRadius: 'base',
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      backgroundColor: 'brandColors.greyscale',
      _hover: {
        background: 'brandColors.greyscale80',
      },
    },
    buttonOutline: {
      display: 'flex',
      height: 13.5,
      py: 4,
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      alignSelf: 'stretch',
      color: 'brandColors.greyscale',
      textAlign: 'center',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      borderRadius: 'base',
      border: '1px solid',
      borderColor: 'brandColors.greyscale90',
      backgroundColor: 'transparent',
      _hover: {
        background: 'brandColors.greyscale10',
      },
      sx: {
        '& svg': {
          width: 5,
          height: 5,
          mr: 0,
        },
      },
    },
    divider: {
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      whiteSpace: 'nowrap',
      color: 'brandColors.primaryText',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '120%',
      sx: {
        '&:before, &:after': {
          content: '""',
          display: 'block',
          height: '1px',
          width: 'full',
          background: 'brandColors.greyscale10',
        },
      },
    },
    policy: {
      gap: 4,
    },
    policyText: {
      color: 'brandColors.greyscale60',
      fontSize: 'xs',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '140%',
    },
    policyLink: {
      color: 'brandColors.primaryDarkLinen',
      fontWeight: 'medium',
    },
    buttonForgotPassword: {
      color: 'brandColors.primaryDarkLinen',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: '120%',
      textDecorationLine: 'underline',
      textUnderlineOffset: '0.35em',
      _hover: {
        textDecoration: 'none',
      },
    },
  },
};

export default FormAuth;
